import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { EmptyStateProps } from './types';
import { MESSAGES } from './constants';
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateSubtext,
} from './styles';

const EmptyState: React.FC<EmptyStateProps> = ({ hasFilters, isDark }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon $isDark={isDark}>
        <FontAwesomeIcon icon={faDesktop} />
      </EmptyStateIcon>
      <EmptyStateTitle $isDark={isDark}>
        {MESSAGES.NO_DEVICES_FOUND}
      </EmptyStateTitle>
      <EmptyStateSubtext $isDark={isDark}>
        {hasFilters ? MESSAGES.ADJUST_SEARCH : MESSAGES.ADD_FIRST_DEVICE}
      </EmptyStateSubtext>
    </EmptyStateContainer>
  );
};

export default EmptyState;
